import { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Layout } from '@hcrshubham/core-components';
import { Post } from '@hcrshubham/store';
import fs from 'fs';
import matter from 'gray-matter';
import { GetStaticProps } from 'next';
import Link from 'next/link';
import path from 'path';
import { NextSeo } from 'next-seo';
import { CASE_STUDIES_PATH, caseStudiesFilePaths } from '../../utils/mdx.utils';

export const getStaticProps: GetStaticProps<PortfolioPageProps> = () => {
  const caseStudies = caseStudiesFilePaths
    .map((filePath) => {
      const fileContents = fs.readFileSync(path.join(CASE_STUDIES_PATH, filePath));
      const fileMetadata = fs.statSync(path.join(CASE_STUDIES_PATH, filePath));
      const { content, data } = matter(fileContents);

      return {
        content,
        metadata: {
          ...data,
          created: fileMetadata.ctime.toISOString(),
          modified: fileMetadata.mtime.toISOString(),
          date: data.date || '01-Jan-2000', // Default if missing
        },
        filePath,
      };
    })
    .sort((a, b) => {
      const dateA = new Date(a.metadata.date);
      const dateB = new Date(b.metadata.date);
      return dateB.getTime() - dateA.getTime(); // Newest first
    });

  return { props: { caseStudies } };
};

type PortfolioPageProps = {
  caseStudies: Post[];
};

const PortfolioPage = ({ caseStudies }: PortfolioPageProps) => {
  const [filter, setFilter] = useState('All');
  const [filteredStudies, setFilteredStudies] = useState(caseStudies);

  // Apply filter
  useEffect(() => {
    setFilteredStudies(
      filter === 'All' ? caseStudies : caseStudies.filter(study => study.metadata.category === filter)
    );

    // Ensure aanimations work by delaying AOS reinit
    setTimeout(() => {
      AOS.refresh();
    }, 50);
  }, [filter, caseStudies]);

  useEffect(() => {
    AOS.init({ duration: 500, once: false });
  }, []);
  const siteUrl = (process.env.NEXT_PUBLIC_SITE_URL || 'https://shubhamsharma.in').replace(/\/$/, '');

  return (
    <>
      <NextSeo
        title="Certificates - Shubham Kumar Sharma"
        description="Discover awards and recognitions received by Shubham Kumar Sharma throughout his career as a developer."
        canonical={`${siteUrl}/certificates`}
      />
    <Layout wrapperClass="main-workspage">
      <section className="projects-area">
        <h1 className="section-heading" id='forAnC' data-aos="fade-up">
          <img src="/assets/star-2.png" alt="Star" /> Awards & Certificates          {' '}
          <img src="/assets/star-2.png" alt="Star" />
        </h1>

        {/* Styled Filter Menu */}
        <div className="filter-menu">
          {['All', 'Awards', 'Certificates'].map(category => (
            <button 
              key={category} 
              className={`filter-button ${filter === category ? 'active' : ''}`} 
              onClick={() => setFilter(category)}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="container">
          {/* Using a key on the row to force a full re-render when filter changes */}
          <div className="row" key={filter}>
            {filteredStudies.map((study, i) => (
              <div key={study.filePath} className="col-md-4" data-aos="zoom-in">
                <div className="project-item shadow-box">
                  <Link
                    className="overlay-link"
                    as={`/certificates/${study.filePath.replace(/\.mdx?$/, '')}`}
                    href={`/certificates/[entry]`}
                    aria-label={`Open certificate: ${study.metadata.title}`}
                  />
                  <img src="/assets/bg1.png" alt="BG" className="bg-img" />
                  <div className="project-img">
                    <img src={study.metadata.thumbnail} alt="thumbnail" />
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="project-info">
                      <p>{study.metadata.category}</p>
                      <h1>{study.metadata.title}</h1>
                      <h6 id='metadataDate'>{study.metadata.date}</h6>
                    </div>
                    <Link
                      as={`/certificates/${study.filePath.replace(/\.mdx?$/, '')}`}
                      href={`/certificates/[entry]`}
                      className="project-btn"
                    >
                      <img src="/assets/icons/cta-icon.svg" alt="Button" />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </Layout>
    </>
  );
};

export default PortfolioPage;
